"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRegistry = void 0;
const proto_signing_1 = require("@cosmjs/proto-signing");
const tx_1 = require("cosmjs-types/cosmos/distribution/v1beta1/tx");
const constants_1 = require("../../constants");
const btcstakingtx = __importStar(require("../../generated/babylon/btcstaking/v1/tx"));
const epochingtx = __importStar(require("../../generated/babylon/epoching/v1/tx"));
const incentivetx = __importStar(require("../../generated/babylon/incentive/tx"));
// List of protos to register in the registry
const protosToRegister = [
    // BTC Staking - Creating a BTC delegation
    {
        typeUrl: constants_1.REGISTRY_TYPE_URLS.MsgCreateBTCDelegation,
        messageType: btcstakingtx.MsgCreateBTCDelegation,
    },
    // BTC Staking - Expanding a BTC delegation
    {
        typeUrl: constants_1.REGISTRY_TYPE_URLS.MsgBtcStakeExpand,
        messageType: btcstakingtx.MsgBtcStakeExpand,
    },
    // Incentives - Withdrawing BABY rewards from BTC Staking
    {
        typeUrl: constants_1.REGISTRY_TYPE_URLS.MsgWithdrawRewardForBTCStaking,
        messageType: incentivetx.MsgWithdrawReward,
    },
    // Epoching - Staking / Unstaking BABY
    {
        typeUrl: constants_1.REGISTRY_TYPE_URLS.MsgStakeBABY,
        messageType: epochingtx.MsgWrappedDelegate,
    },
    {
        typeUrl: constants_1.REGISTRY_TYPE_URLS.MsgUnstakeBABY,
        messageType: epochingtx.MsgWrappedUndelegate,
    },
    // Cosmos Distribution - Withdrawing rewards from BABY Staking
    {
        typeUrl: constants_1.REGISTRY_TYPE_URLS.MsgWithdrawRewardForBABYStaking,
        messageType: tx_1.MsgWithdrawDelegatorReward,
    },
];
// Utility function to create a `GeneratedType` from `MessageFns`
// Temporary workaround until https://github.com/cosmos/cosmjs/issues/1613 is fixed
const createGeneratedType = (messageType) => {
    return {
        encode: messageType.encode.bind(messageType),
        decode: messageType.decode.bind(messageType),
        fromPartial: (properties) => {
            return messageType.fromPartial(properties ?? {});
        },
    };
};
// Create the registry with the protos to register
const createRegistry = () => {
    const registry = new proto_signing_1.Registry();
    protosToRegister.forEach((proto) => {
        const generatedType = createGeneratedType(proto.messageType);
        registry.register(proto.typeUrl, generatedType);
    });
    return registry;
};
exports.createRegistry = createRegistry;
//# sourceMappingURL=registry.js.map